export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11579.eb14db51.jpg";